import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { handleOnKeyDown } from 'src/utils/Form'
import { formatDateReplaceHour } from 'src/utils/formatDate'
import { selectDataToExecuteInventory, selectDataPosition } from '../../InventorySelector'
import { actions } from '../../InventoryState'
import ModalConfirmFinishPosition from '../ModalConfirmFinishPosition'
import { UnlinkOperator } from '../UnlinkOperator/UnlinkOperator'
import * as S from './ExecutingCount.styles'
import { Divider } from '@mui/material'
import { fixInputSx, fixInputSxWithCustomColor } from '../../utils'

interface List {
  quantity: number,
  expirationDate: Date,
}

interface Props {
  inventoryToExecute: any
  setClickStartPosition: (value: boolean) => void,
}

export const ExecutingCount = ({ inventoryToExecute, setClickStartPosition }: Props) => {
  const dispatch = useDispatch()
  const position = useSelector(selectDataPosition)
  const { badge } = useSelector(selectDataToExecuteInventory)

  const [totalQuantity, setTotalQuantity] = useState<number>(position.openCount === true ? position.currentTotal : 0)
  const [totalQuantityDamage, setTotalQuantityDamage] = useState<number>(position.openCount === true ? position.currentDamage : 0)
  const [listInventoryValidate, setListInventoryValidate] = useState<List[]>([])
  const [clickDamage, setClickDamage] = useState(false)
  const [hasPosition, setHasPosition] = useState(false)
  const [openModalConfirmFinish, setOpenModalConfirmFinish] = useState(false)
  const [clickUnlinkOperator, setClickUnlinkOperator] = useState(false)

  const {
    register, getValues, setValue, setError, formState: { errors },
  } = useForm()

  const onClickSaveSimpleType = () => {
    const quantity: number = getValues('quantityPosition')

    if (!quantity) {
      setError('quantityPosition', { message: 'Campo obrigatório' })
      return
    }

    if (quantity < 0) {
      setError('quantityPosition', { message: 'Deve ser no mínimo 0' })
      return
    }

    if (quantity > 99999) {
      setError('quantityPosition', { message: 'Deve ter no máximo 5 dígitos' })
      return
    }

    dispatch(actions.savePosition({
      idPosition: position.idPosition,
      quantity,
      setHasPosition,
      badge,
    }))

    setTotalQuantity(Number(totalQuantity) + Number(quantity))
    setValue('quantityPosition', '')
  }

  const onClickSaveValidateType = () => {
    const quantity = getValues('quantityPosition')
    const expirationDate = getValues('expirationDate')

    if (!quantity && expirationDate) {
      setError('quantityPosition', { message: 'Campo obrigatório' })
      return
    } if (quantity && !expirationDate) {
      setError('expirationDate', { message: 'Campo obrigatório' })
      return
    } if (!quantity && !expirationDate) {
      setError('quantityPosition', { message: 'Campo obrigatório' })
      setError('expirationDate', { message: 'Campo obrigatório' })
      return
    }

    if (quantity < 0) {
      setError('quantityPosition', { message: 'Deve ser no mínimo 0' })
      return
    }

    if (quantity > 99999) {
      setError('quantityPosition', { message: 'Deve ter no máximo 5 dígitos' })
      return
    }

    dispatch(actions.savePosition({
      idPosition: position.idPosition,
      quantity,
      expirationDate,
      setHasPosition,
      badge,
    }))

    const existExpirationDate = listInventoryValidate.find((item) => item.expirationDate === expirationDate)
    if (existExpirationDate) {
      const newList = listInventoryValidate.map((item) => {
        if (item.expirationDate === expirationDate) {
          setTotalQuantity(Number(totalQuantity) + Number(item.quantity))
          return { ...item, quantity: Number(item.quantity) + Number(quantity) }
        }
        return item
      })
      setListInventoryValidate(newList)
    } else {
      setListInventoryValidate([...listInventoryValidate, { quantity, expirationDate }])
      setTotalQuantity(Number(totalQuantity) + Number(quantity))
    }
    setValue('quantityPosition', '')
    setValue('expirationDate', '')
  }

  const onClickSavePositionDamage = () => {
    const quantityDamage = getValues('quantityDamage')
    const expirationDateDamage = getValues('expirationDateDamage')

    if (position.countType === 'Simples' && !quantityDamage) {
      setError('quantityDamage', { message: 'Campo obrigatório' })
      return
    } if (position.countType === 'Validade' && !quantityDamage && expirationDateDamage) {
      setError('quantityDamage', { message: 'Campo obrigatório' })
      return
    } if (position.countType === 'Validade' && quantityDamage && !expirationDateDamage) {
      setError('expirationDateDamage', { message: 'Campo obrigatório' })
      return
    } if (position.countType === 'Validade' && !quantityDamage && !expirationDateDamage) {
      setError('quantityDamage', { message: 'Campo obrigatório' })
      setError('expirationDateDamage', { message: 'Campo obrigatório' })
      return
    }

    if (quantityDamage < 0) {
      setError('quantityDamage', { message: 'Deve ser no mínimo 0' })
      return
    }

    if (quantityDamage > 99999) {
      setError('quantityDamage', { message: 'Deve ter no máximo 5 dígitos' })
      return
    }

    if (position.countType === 'Validade') {
      dispatch(actions.savePositionDamage({
        idPosition: position.idPosition,
        quantityDamage,
        expirationDateDamage,
        badge,
      }))
    }

    if (position.countType === 'Simples') {
      dispatch(actions.savePositionDamage({
        idPosition: position.idPosition,
        quantityDamage,
        badge,
      }))
    }

    setClickDamage(false)
    setTotalQuantityDamage(Number(totalQuantityDamage) + Number(quantityDamage))
    setValue('quantityDamage', '')
    setValue('expirationDateDamage', '')
  }

  const onClickCancelItemValidateType = (quantity, expirationDate) => {
    dispatch(actions.cancelQuantityItem({
      idPosition: position.idPosition,
      expirationDate,
      badge,
    }))
    setTotalQuantity(Number(totalQuantity) - Number(quantity))
    setListInventoryValidate(listInventoryValidate.filter((item) => item.expirationDate !== expirationDate))
  }

  const onClickCancelItemSimpleType = (quantity, quantityDamage) => {
    dispatch(actions.cancelQuantityItem({
      idPosition: position.idPosition,
      badge,
    }))
    setTotalQuantity(Number(totalQuantity) - Number(quantity))
    setTotalQuantityDamage(Number(totalQuantityDamage) - Number(quantityDamage))
  }

  const onClickFinishPosition = () => {
    setOpenModalConfirmFinish(true)
  }

  const disabledFinish = () => {
    if (position.currentTotal > 0) {
      return false
    }
    if (hasPosition === false) {
      return true
    }
    return false
  }

  if (clickUnlinkOperator) return <UnlinkOperator setClickUnlinkOperator={setClickUnlinkOperator} />

  return (
    <S.Wrapper>
      {position.countType === 'Simples' ? (
        <h6>Contagem simples</h6>
      ) : position.countType === 'Validade' ? (
        <h6>Contagem validade</h6>) : ''}
      <S.ContainerPosition>
        <p>{position.operatorName} <S.RemoveBatchButton size={18} data-testid='trash-button-test' onClick={() => setClickUnlinkOperator(true)} /> </p>
        <p><strong>{position.productDescription}</strong></p>
        <p>{position.positionAddress}</p>
      </S.ContainerPosition>
      <Divider flexItem />
      {position.countType === 'Simples' ? (
        <>
          <S.ContainerTotal>
            <span><strong>Úteis: {totalQuantity}</strong></span>
            <span><strong>Avarias: {totalQuantityDamage}</strong></span>
            <span><strong>Total: {totalQuantity + totalQuantityDamage}</strong></span>
            <S.CustomButtonReset
              title='Resetar contagem'
              bgColor='cancel'
              hoverColor='cancelHover'
              letterColor='white'
              onClick={() => onClickCancelItemSimpleType(totalQuantity, totalQuantityDamage)}
              data-testid='button-reset-test'
            />
          </S.ContainerTotal>
          <S.ContainerQuantity>
            <S.CustomTextField
              sx={{ ...fixInputSx }}
              id='quantityPosition'
              name='quantityPosition'
              type='number'
              autoComplete='off'
              inputProps={{
                ...register('quantityPosition',
                  {
                    required: 'Campo obrigatório',
                    min: { value: 0, message: 'Deve ser no mínimo 0' },
                  }),
                'data-testid': 'input-quantity-test',
              }}
              error={!!errors.quantityPosition}
              label='quantity.in.position'
              helperText={errors.quantityPosition?.message}
              fullWidth
              size='medium'
              onKeyDown={(e) => handleOnKeyDown(e, '', onClickSaveSimpleType)}
            />
            <S.CustomButtonAddSimple
              title='Adicionar'
              bgColor='confirm'
              hoverColor='confirmHover'
              letterColor='white'
              onClick={() => onClickSaveSimpleType()}
              data-testid='button-add-quantity-test'
            />
          </S.ContainerQuantity>
          <Divider flexItem />
          {clickDamage && position.countType === 'Simples' && (
          <S.ContainerDamage>
            <S.CustomTextFieldDamage
              sx={{
                ...fixInputSxWithCustomColor(undefined, 'orange', 'orange', 'orange'),
              }}
              id='quantityDamage'
              name='quantityDamage'
              type='number'
              autoComplete='off'
              inputProps={{
                ...register('quantityDamage',
                  {
                    required: 'Campo obrigatório',
                    min: { value: 0, message: 'Deve ser no mínimo 0' },
                  }),
                'data-testid': 'input-quantity-damage-test',
              }}
              error={!!errors.quantityDamage}
              label='quantity.in.position'
              helperText={errors.quantityDamage?.message}
              fullWidth
              size='medium'
              onKeyDown={(e) => handleOnKeyDown(e, '', onClickSavePositionDamage)}
            />
            <S.ContainerButtonDamage>
              <S.CustomButtonDamageFinish
                title='Adicionar'
                bgColor='confirm'
                hoverColor='confirmHover'
                letterColor='white'
                onClick={() => onClickSavePositionDamage()}
                data-testid='button-add-quantity-damage-test'
              />
              <S.CustomButtonDamageFinish
                title='Cancelar'
                bgColor='lightRed'
                hoverColor='cancelHover'
                letterColor='white'
                onClick={() => setClickDamage(false)}
              />
            </S.ContainerButtonDamage>
          </S.ContainerDamage>
          )}
          {!clickDamage && (
          <S.ContainerButtonZeroBottom>
            <S.CustomButtonDamageFinish
              title='Avaria'
              bgColor='lightRed'
              hoverColor='cancelHover'
              letterColor='white'
              onClick={() => setClickDamage(true)}
              data-testid='button-damage-test'
            />
            <S.CustomButtonDamageFinish
              title='Finalizar'
              bgColor='blue'
              hoverColor='darkBlueHover'
              letterColor='white'
              disabled={disabledFinish()}
              onClick={() => onClickFinishPosition()}
              data-testid='button-finish-position-test'
            />
          </S.ContainerButtonZeroBottom>
          )}
        </>
      ) : position.countType === 'Validade' ? (
        <>
          <p><strong>Avarias:</strong> {totalQuantityDamage} <strong>Total:</strong> {totalQuantity}</p>
          <S.ContainerQuantity>
            <S.CustomTextFieldQuantityValidate
              id='quantityPosition'
              name='quantityPosition'
              type='number'
              autoComplete='off'
              inputProps={{
                ...register('quantityPosition',
                  {
                    required: 'Campo obrigatório',
                    min: { value: 0, message: 'Deve ser no mínimo 0' },
                  }),
                'data-testid': 'input-quantity-test',
              }}
              error={!!errors.quantityPosition}
              label='quantity.in.position'
              helperText={errors.quantityPosition?.message}
              fullWidth
              size='medium'
              onKeyDown={(e) => handleOnKeyDown(e, 'expirationDate')}
            />
            <S.CustomTextFieldExpirationDate
              sx={{ ...fixInputSx }}
              id='expirationDate'
              name='expirationDate'
              type='date'
              autoComplete='off'
              inputProps={{
                ...register('expirationDate',
                  {
                    required: 'Campo obrigatório',
                    min: { value: 0, message: 'Deve ser no mínimo 0' },
                  }),
                'data-testid': 'input-expiration-date-test',
              }}
              error={!!errors.expirationDate}
              label='expiration.date.inventory'
              helperText={errors.expirationDate?.message}
              fullWidth
              size='medium'
              InputLabelProps={{ shrink: true }}
              onKeyDown={(e) => handleOnKeyDown(e, '', onClickSaveValidateType)}
            />
            <S.CustomButtonAddValidate
              title='Adicionar'
              bgColor='confirm'
              hoverColor='confirmHover'
              letterColor='white'
              onClick={() => onClickSaveValidateType()}
              data-testid='button-add-quantity-test'
            />
          </S.ContainerQuantity>
          <S.ContainerList>
            {listInventoryValidate.length > 0 && listInventoryValidate.map((item, index) => (
              <S.ContainerItem key={index}>
                <p>Quantidade: {item.quantity}</p>
                <p>Validade: {formatDateReplaceHour(item.expirationDate)}</p>
                <S.RemoveBatchButton size={20} data-testid='trash-button-test' onClick={() => onClickCancelItemValidateType(item.quantity, item.expirationDate)} />
              </S.ContainerItem>
            ))}
          </S.ContainerList>
          <Divider flexItem />
          {clickDamage && position.countType === 'Validade' && (
          <S.ContainerDamage>
            <S.ContainerTextField>
              <S.CustomTextFieldDamageValidate
                sx={{
                  ...fixInputSxWithCustomColor(undefined, 'orange', 'orange', 'orange'),
                }}
                id='quantityDamage'
                name='quantityDamage'
                type='number'
                autoComplete='off'
                inputProps={{
                  ...register('quantityDamage',
                    {
                      required: 'Campo obrigatório',
                      min: { value: 0, message: 'Deve ser no mínimo 0' },
                    }),
                  'data-testid': 'input-quantity-damage-test',
                }}
                error={!!errors.quantityDamage}
                label='quantity.in.position'
                helperText={errors.quantityDamage?.message}
                fullWidth
                size='medium'
                onKeyDown={(e) => handleOnKeyDown(e, 'expirationDateDamage')}
              />
              <S.CustomTextFieldExpirationDate
                sx={{ ...fixInputSx }}
                id='expirationDateDamage'
                name='expirationDateDamage'
                type='date'
                autoComplete='off'
                inputProps={{
                  ...register('expirationDateDamage',
                    {
                      required: 'Campo obrigatório',
                      min: { value: 0, message: 'Deve ser no mínimo 0' },
                    }),
                  'data-testid': 'input-expiration-date-damage-test',
                }}
                error={!!errors.expirationDateDamage}
                label='expiration.date.inventory'
                helperText={errors.expirationDateDamage?.message}
                fullWidth
                size='medium'
                InputLabelProps={{ shrink: true }}
                onKeyDown={(e) => handleOnKeyDown(e, '', onClickSavePositionDamage)}
              />
            </S.ContainerTextField>
            <S.ContainerButtonDamageValidate>
              <S.CustomButtonDamageFinish
                title='Adicionar'
                bgColor='confirm'
                hoverColor='confirmHover'
                letterColor='white'
                onClick={() => onClickSavePositionDamage()}
                data-testid='button-add-quantity-damage-test'
              />
              <S.CustomButtonDamageFinish
                title='Cancelar'
                bgColor='lightRed'
                hoverColor='cancelHover'
                letterColor='white'
                onClick={() => setClickDamage(false)}
              />
            </S.ContainerButtonDamageValidate>
          </S.ContainerDamage>
          )}
          {!clickDamage && (
          <S.ContainerButtonZeroBottom>
            <S.CustomButtonDamageFinish
              title='Avaria'
              bgColor='lightRed'
              hoverColor='cancelHover'
              letterColor='white'
              onClick={() => setClickDamage(true)}
              data-testid='button-damage-test'
            />
            <S.CustomButtonDamageFinish
              title='Finalizar'
              bgColor='blue'
              hoverColor='darkBlueHover'
              letterColor='white'
              disabled={disabledFinish()}
              onClick={() => onClickFinishPosition()}
              data-testid='button-finish-position-test'
            />
          </S.ContainerButtonZeroBottom>
          )}
        </>
      ) : <> </>}
      <ModalConfirmFinishPosition
        open={openModalConfirmFinish}
        setOpen={setOpenModalConfirmFinish}
        setHasPosition={setHasPosition}
        inventoryToExecute={inventoryToExecute}
        setClickStartPosition={setClickStartPosition}
      />
    </S.Wrapper>
  )
}
